export const seededPancakes = {
  id: "seededPancakes",
  link: "/#/recipes/recipes/seededPancakes",
  name: "Sesame Seed Pancakes",
  cuisine: "Tashikki",
  summary: "Large savory pancakes coated with toasted sesame seeds",
  inspiration: null,
  quantity: "4 8-9 inch pancakes",
  time: "45 minutes",
  notes:
    "There was never really any question to me that these pancakes would feature toasted sesame seeds. I decided to use sesame in other recipes, and they just fit the description so well. The only remaining question then was what type of batter to use. I went with an egg-heavy batter to distinguish from the fluffy whipped-egg-whites pancakes. Feel free to use any toppings you wish.",
  quotes:
    "Lift chewed on her pancake... The one beside it was covered in little crunchy seeds. (Edgedancer ch 14)",
  image: "https://jozomby-public.s3.amazonaws.com/recipes/seeded-pancakes-overview.jpg",
  ingredientSections: [
    {
      title: null,
      ingredients: [
        {
          item: "rice",
          display: "2/3 cup rice flour"
        },
        {
          item: "salt",
          display: "1/4 tsp salt"
        },
        {
          item: "water",
          display: "1 cup water"
        },
        {
          item: "oliveOil",
          display: "2 tbsp olive oil"
        },
        {
          item: "eggs",
          display: "2 lightly beaten eggs"
        },
        {
          item: "sesame",
          display: "8 tbsp sesame seeds, divided"
        },
        {
          item: "dairy",
          display: "4 tbsp butter, divided"
        },
        {
          item: "onion",
          display: "4 green onions"
        }
      ]
    }
  ],
  steps: [
    "Combine the rice flour and salt in a medium bowl. In another bowl, mix together the water, olive oil and eggs. Pour the wet ingredients into the bowl with the dry ingredients. Whisk very well until smooth.",
    "Heat a 8 to 9 inch non stick skillet over medium low heat until very hot. Sprinkle 2 tbsp sesame seeds evenly in the pan. Toast 1 to 2 minutes, stirring or shaking occasionally, until browned.",
    "Spread the seeds out evenly in the pan again. Mix the batter again briefly if it has started to separate. Gently pour 1/3 to 1/2 cup of the batter into the pan in a thin stream, in a spiral motion working out from the center to cover the entire pan with a thin layer of batter. Use just enough batter to cover the pan. If there are a few uncovered holes, tilt the pan to encourage the batter to run into the holes and fill them.",
    "Cook about 4 minutes or until lightly browned on the bottom. Carefully flip the pancake, then cook another 2 minutes until lightly browned. Press the pancake down if it tries to lift up off the pan in the center. Remove from the pan and repeat with the rest of the batter to make 4 pancakes.",
    "Chop the green onion, and serve each pancake topped with 1 tbsp of butter and 1 chopped green onion."
  ]
}
